import { Spinner } from '~/DesignSystem/components/spinner'

import { Layout } from '../Layout'

export function LayoutSpinner() {
  return (
    <Layout className="justify-center items-center">
      <Spinner className="size-16 opacity-15" />
    </Layout>
  )
}
